import * as React from 'react';

export const CalendarActiveIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Leading">
      <path
        id="Vector"
        opacity="0.4"
        d="M2.5 15.001C2.5 16.6676 3.33333 17.501 5 17.501H15C16.6667 17.501 17.5 16.6676 17.5 15.001V7.50098H2.5V15.001Z"
        fill="#1D6EAA"
      />
      <path
        id="Vector_2"
        d="M15 3.75098H13.9583V2.50098C13.9583 2.15598 13.6783 1.87598 13.3333 1.87598C12.9883 1.87598 12.7083 2.15598 12.7083 2.50098V3.75098H7.29167V2.50098C7.29167 2.15598 7.01167 1.87598 6.66667 1.87598C6.32167 1.87598 6.04167 2.15598 6.04167 2.50098V3.75098H5C3.33333 3.75098 2.5 4.58431 2.5 6.25098V7.50098H17.5V6.25098C17.5 4.58431 16.6667 3.75098 15 3.75098Z"
        fill="#1D6EAA"
      />
      <path
        id="Vector_3"
        d="M6.68331 11.6676C6.22331 11.6676 5.8457 11.2943 5.8457 10.8343C5.8457 10.3743 6.21497 10.001 6.67497 10.001H6.68331C7.14414 10.001 7.51664 10.3743 7.51664 10.8343C7.51664 11.2943 7.14331 11.6676 6.68331 11.6676ZM10.85 10.8343C10.85 10.3743 10.4775 10.001 10.0166 10.001H10.0083C9.5483 10.001 9.17904 10.3743 9.17904 10.8343C9.17904 11.2943 9.55664 11.6676 10.0166 11.6676C10.4766 11.6676 10.85 11.2943 10.85 10.8343ZM14.1833 10.8343C14.1833 10.3743 13.8108 10.001 13.35 10.001H13.3416C12.8816 10.001 12.5124 10.3743 12.5124 10.8343C12.5124 11.2943 12.89 11.6676 13.35 11.6676C13.81 11.6676 14.1833 11.2943 14.1833 10.8343ZM7.51664 14.1676C7.51664 13.7076 7.14414 13.3343 6.68331 13.3343H6.67497C6.21497 13.3343 5.8457 13.7076 5.8457 14.1676C5.8457 14.6276 6.22331 15.001 6.68331 15.001C7.14331 15.001 7.51664 14.6276 7.51664 14.1676ZM10.85 14.1676C10.85 13.7076 10.4775 13.3343 10.0166 13.3343H10.0083C9.5483 13.3343 9.17904 13.7076 9.17904 14.1676C9.17904 14.6276 9.55664 15.001 10.0166 15.001C10.4766 15.001 10.85 14.6276 10.85 14.1676ZM14.1833 14.1676C14.1833 13.7076 13.8108 13.3343 13.35 13.3343H13.3416C12.8816 13.3343 12.5124 13.7076 12.5124 14.1676C12.5124 14.6276 12.89 15.001 13.35 15.001C13.81 15.001 14.1833 14.6276 14.1833 14.1676Z"
        fill="#1D6EAA"
      />
    </g>
  </svg>
);
